// extracted by mini-css-extract-plugin
export default {"cls1":"Reader-cls1_x62","cls2":"Reader-cls2_SXn Reader-cls1_x62"};